const getQuestionText = (html, type = 'application/xml') => {
  const document = new DOMParser().parseFromString(html, type);
  const parserError = document.querySelector('parsererror');

  if (parserError) {
    return parserError.textContent;
  }

  return document.documentElement.textContent;
};

export { getQuestionText };
